import React,{useCallback, useEffect} from "react";
import { useSelector } from "react-redux";
import { AddBtn } from "@commonComponents/AddBtn";
import { FormTitle } from "@commonComponents/FormTitle";
import { selectArrivalTransportDS, selectMotTypeList } from "@EUForms/selectors";
import { defaultTransMode } from "../../util";

const ArrivalTransportDetail = ({ translate, renderForm, addItem, tableName = "arrivalTransportMeansList", updateItem: onChange, saveItem: onBlur, onSelect }) => {
    const dataSource = useSelector(selectArrivalTransportDS);
    console.log("dataSource?.[0]?.id,___",dataSource?.[0]?.id)
    let motTypeList = useSelector(selectMotTypeList)
    motTypeList = dataSource?.[0]?.modeOfTransport ? motTypeList?.filter((motType) => {
        return ['1', '2', '3', '4', '8'].includes(dataSource?.[0]?.modeOfTransport)
            ? motType.value.startsWith(dataSource?.[0]?.modeOfTransport)
            : true
    }) : []
    const onDropDownChange = useCallback((id, tableName, payload) => {
        if (payload.hasOwnProperty("modeOfTransport") && (!payload.modeOfTransport||!defaultTransMode?.[payload.modeOfTransport]))
            onSelect(id, tableName, { ...payload, type: '' })
        else if(payload.hasOwnProperty("modeOfTransport") && defaultTransMode?.[payload.modeOfTransport])
            onSelect(id, tableName, { ...payload, type: defaultTransMode?.[payload.modeOfTransport] })
        else
            onSelect(id, tableName, payload)
    }, [onSelect])   
    
    useEffect(() => {
        if (!dataSource?.[0]?.nationality) {
            onDropDownChange(
                dataSource?.[0]?.id,
                'arrivalTransportMeansList',
                { nationality: 'NL' }
            )
        }
    }, [])

    return (
        <div className="grow mb-2 col formContainer">
            <FormTitle className="formTitle" textAlign="start" boxNumber="7/9" title="Arrival Transport Means" />
            {dataSource.length > 0 ? renderForm({ onChange, onBlur, dataSource: dataSource[0], motTypeList, onSelect:onDropDownChange, tableName, translate }) : <AddBtn style={{ width: "max-content" }} onClick={() => addItem(tableName)} text={translate("ADD")} />}
        </div>
    )
}

export default React.memo(ArrivalTransportDetail)
